import $ from 'jquery';
import 'core-js/modules/es.object.assign';
import { dawaAutocomplete } from 'dawa-autocomplete2';

$(() => {
    $('.dawaContact').each((index, input) => {
        const contactIndex = $(input).data('contact-index');
        const cName =`[name="caseBean.contacts[${contactIndex}].`;
        dawaAutocomplete(input, {
            select(selected) {
                fetch(selected.data.href)
                    .then(response => response.json())
                    .then(data => {
                        $(cName + 'streetName"]').val(data.adgangsadresse.vejstykke.navn || '');
                        $(cName + 'buildingNumber"]').val(data.adgangsadresse.husnr || '');
                        $(cName + 'floorNumber"]').val(data.etage || '');
                        $(cName + 'suiteNumber"]').val(data.dør || '');
                        $(cName + 'postalCode"]').val(data.adgangsadresse.postnummer.nr || '');
                        $(cName + 'postalDistrict"]').val(data.adgangsadresse.postnummer.navn || '');
                    });
            }
        });
    });
});
